import { StoreJsAPILike } from "./types";

/**
 * Creates a wrapper around a StoreJS-like object, which will encapsulate all function to act within the namespace
 *
 * @param store
 * @param namespace
 * @param delimiter
 */
export function getNamespacedStore({
  store,
  namespace,
  delimiter = "_",
}: {
  store: StoreJsAPILike;
  namespace: string;
  delimiter?: string;
}): StoreJsAPILike {
  if (!namespace || !/^[A-Za-z0-9_.\-]+$/.test(namespace)) {
    throw new Error(`empty or invalid namespace: "${namespace}"`);
  }

  // use rootStore and extend parent namespace if available.
  const nsRef = (store as any).namespaceRef || "";
  store = store.rootStore || store;
  const ns = `${nsRef}${namespace}${delimiter}`;
  return Object.freeze({
    get(key: string, optionalDefaultValue?: any): any {
      return store.get(`${ns}${key}`, optionalDefaultValue);
    },
    remove(key: string): void {
      return store.remove(`${ns}${key}`);
    },
    each(callback: (val: any, key: string) => void): void {
      return store.each((innerVal, innerKey) => {
        if (innerKey.startsWith(ns)) {
          return callback(innerVal, innerKey.substr(ns.length));
        }
      });
    },
    set(key: string, value: any): any {
      return store.set(`${ns}${key}`, value);
    },
    watch(key: string, callback: (val: any) => void): void {
      return store.watch(`${ns}${key}`, callback);
    },
    unwatch(key: string): void {
      return store.unwatch(`${ns}${key}`);
    },
    isNamespaced: true,
    namespaceRef: ns, // weird name to avoid collision
    rootStore: store,
  });
}
